import { Auth } from '@nackle/bridge';
import { AUTHORITY } from 'endpoints';

const auth = new Auth( { authority: AUTHORITY } );
export default auth;


export const PERMISSIONS = {
    LIST_EXPERIENCES: 'experience-registry-api.list-experiences',
    READ_EXPERIENCE: 'experience-registry-api.read-experience',
    EDIT_EXPERIENCE: 'experience-registry-api.edit-experience',
    DELETE_EXPERIENCE: 'experience-registry-api.delete-experience'
};